<template>
  <div class="tab-actions">
    <type
      :key="type.name"
      :icon="type.icon"
      :title="type.name"
      v-for="type in types"
    />
  </div>
</template>

<script>
import Type from './Type'

export default {
  name: 'Elements',
  components: {
    Type,
  },
  data: () => ({
    types: [
      {
        icon: 'envelope',
        name: 'NewPostback',
      }, 
      {
        icon: 'ellipsis-h',
        name: 'Delay',
      }, 
      {
        icon: 'tag',
        name: 'Labels',
      },
      {
        icon: 'plane-departure',
        name: 'Triggers',
      },
      {
        icon: 'bell',
        name: 'OTN',
      },
    ]
  }),
}
</script>

<style scoped>
.tab-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-content: center;
  align-items: center;
}
</style>